import sensorDataConfigApi from '@/api/config/sensorDataConfig'
import { queryKeys } from '@/constant/common'
import { SensorDetailCis } from '@/types/sensor'
import { useQuery } from '@tanstack/react-query'

const useInputDecoderReadings = (
  interfaceId: number,
  address: number,
  ioId: number,
) => {
  return useQuery<SensorDetailCis | null>(
    [queryKeys.controller, 'input-decoder-readings', interfaceId, address, ioId],
    async () => {
      if (!interfaceId || !address || !ioId) return null
      const { data } = await sensorDataConfigApi.getSoilSensorCis(
        interfaceId,
        address,
        ioId,
      )
      if (!data) return null
      return data
    },
    {
      cacheTime: 0,
      enabled: false,
    },
  )
}

export default useInputDecoderReadings
